import api from './authService';

export const commissionService = {
  // Get default commission setting (public endpoint)
  getDefault: async () => {
    const response = await api.get('/commission-settings/default');
    return response.data;
  },
};

